import httpClient from '../../services/http-client';
import { API_SUB_URL_SERVICE_PRICE, API_SUB_URL_EXPORT_CSV_FILE, API_SUB_URL_EXPORT_EXCEL_FILE } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_SERVICE_PRICE, LOAD_LIST_SERVICE_PRICE, LOAD_A_SERVICE_PRICE, UPDATE_A_SERVICE_PRICE, DELETE_A_SERVICE_PRICE,
    DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV, DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL
} from '../actionTypes';

// ServicePrices
export const apiLoadListServicePrice = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));
        
        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_SERVICE_PRICE}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_SERVICE_PRICE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAServicePrice = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_SERVICE_PRICE}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_SERVICE_PRICE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewServicePrice = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_SERVICE_PRICE, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_SERVICE_PRICE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAServicePrice = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_SERVICE_PRICE}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_SERVICE_PRICE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAServicePrice = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_SERVICE_PRICE}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_SERVICE_PRICE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiExportServicePriceListToCSV = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV.LOADING));

        httpClient.post(`${API_SUB_URL_EXPORT_CSV_FILE}/service_prices`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV.SUCCESS, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV.FAILURE, error))
            });
    }
};

export const apiExportServicePriceListToExcel = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL.LOADING));

        httpClient.post(`${API_SUB_URL_EXPORT_EXCEL_FILE}/service_prices`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL.SUCCESS, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL.FAILURE, error))
            });
    }
};